export default __webpack_public_path__ + "static/media/20.50f68822.svg";